module.exports = __webpack_public_path__ + "static/media/mobilescreen2.16b5fe87.png";